import { jsx } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';

function Pill({ children, color, backgroundColor, borderColor, className }) {
    return (jsx(Wrapper, { "$backgroundColor": backgroundColor, "$borderColor": borderColor, "$color": color, className: className, children: jsx(StyledTypography, { variant: "buttonSmall", children: children }) }));
}
const Wrapper = styled("div")(({ theme, $color, $backgroundColor, $borderColor }) => ({
    display: "inline-block",
    padding: theme.spacing(0.25, 1),
    borderRadius: theme.spacing(2),
    backgroundColor: $backgroundColor,
    border: `1px solid ${$borderColor}`,
    color: $color,
}));
const StyledTypography = styled(Typography)({
    letterSpacing: 0,
    display: "block",
});

export { Pill };
//# sourceMappingURL=Pill.js.map
